const CAPS = {
  CNES_3708330: "CAPS Infantojuvenil Alda Maria",
  CNES_3296598: "CAPS AD III Alcenir Veras",
  CNES_2298856: "CAPS Martha e Dr. Jacinto",
  CNES_2293269: "CAPS Herbert de Souza",
};

export default CAPS;
